export default "__VITE_ASSET__DCCxyzcX__"